export async function offlineGet(key, requestFn, extractor) {
    const localRaw = localStorage.getItem(key);
    const localData = localRaw ? JSON.parse(localRaw) : null;

    if (navigator.onLine) {
        try {
            const response = await requestFn();

            const data = extractor ? extractor(response) : response?.data ?? response;
            localStorage.setItem(key, JSON.stringify(data));

            return data;
        } catch (error) {
            console.warn(`Fallback offline for ${key}`);
            return localData ?? [];
        }
    }

    return localData ?? [];
}

const QUEUE_KEY = 'offlineQueue';

// =====================
// 📦 Helpers básicos
// =====================

export function getQueue() {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
}

function saveQueue(queue) {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

// =====================
// 📝 Enqueue
// =====================

export function enqueue(action) {
    const queue = getQueue();

    const newItem = {
        id: Date.now(),
        ...action,
        status: 'pending',
        createdAt: new Date().toISOString()
    };

    queue.push(newItem);
    saveQueue(queue);

    console.log('📝 Acción guardada offline:', newItem);

    return newItem;
}

// =====================
// 🔄 Sync
// =====================

export async function syncQueue({ apiClient, showAlert }) {
    let queue = getQueue();

    if (!queue.length) return;

    console.log('🔄 Sincronizando cola...', queue.length);

    let successCount = 0;
    let failedQueue = [];

    for (const item of queue) {
        try {
            switch (item.type) {
                case 'CREATE_TICKET':
                    await apiClient.post('/api/ticket/create', item.payload);
                    break;

                case 'CREATE_EDIT_REQUEST':
                    await apiClient.post('/api/production/edit-request', item.payload);
                    break;

                case 'CREATE_HOURLY_RECORD':
                    await apiClient.post('/api/production/hourly', item.payload);
                    break;

                default:
                    console.warn('⚠️ Tipo no manejado:', item.type);
                    failedQueue.push(item);
                    continue;
            }

            successCount++;
        } catch (error) {
            console.error('❌ Error al sincronizar:', item);
            failedQueue.push({
                ...item,
                lastError: error?.message,
                retries: (item.retries || 0) + 1
            });
        }
    }

    saveQueue(failedQueue);

    // =====================
    // 🔔 Feedback usuario
    // =====================
    if (successCount > 0 && showAlert) {
        showAlert(`Se sincronizaron ${successCount} acción(es) pendiente(s)`, 'success');
    }

    if (failedQueue.length > 0 && showAlert) {
        showAlert(`${failedQueue.length} acción(es) no pudieron sincronizarse`, 'warning');
    }
}

export function getPendingCount() {
    return getQueue().length;
}

export function isDuplicateTimestampOffline(timestamp, existingRecords = []) {
    //const queue = getQueue();

    const target = new Date(timestamp).getTime();

    // // 🔹 1. Revisar cola
    // const existsInQueue = queue.some(
    //     (item) =>
    //         item.type === 'CREATE_HOURLY_RECORD' &&
    //         new Date(item.payload?.timestampHour).getTime() === target
    // );

    // 🔹 2. Revisar registros existentes (backend/cache)
    const existsInRecords = existingRecords.some((record) => new Date(record.timestamp || record.timestampHour).getTime() === target);

    return existsInRecords;
}
